<template>
  <v-row v-if="showMetricBar">
    <v-col
      v-if="!slideMetrics || !!slideMetrics.length"
    >
      <v-skeleton-loader
        type="list-item-avatar"
        class="mx-0"
      />
    </v-col>

    <v-col
      class="py-0"
      else
    >
      <v-sheet
        class="elevation-0"
        style="background: none;"
      >
        <v-slide-group
          v-model="slideMetrics"
        >
          <v-slide-item
            v-for="(metric, index) in metrics"
            :key="index"
          >
            <v-col
              :class="`col-auto${index === 0 ? ' pl-0' : ''}`"
            >
              <v-card
                :class="`pa-0 ${isCurrentlyActiveMetric(metric) || isCurrentlyActiveStandalone(metric) ? 'darkestblue' : 'primary'} white--text`"
                min-width="200px"
                height="104px"
                flat
                @click.stop="toggleMetric(metric)"
              >
                <v-card-text
                  class="white--text pb-0"
                >
                  <v-col>
                    <v-row class="text-uppercase subtitle-2 font-weight-bold text-truncate pr-1">
                      <span style="line-height: 1;">{{ metric.reportLabel }}</span>
                    </v-row>
                  </v-col>
                </v-card-text>

                <v-card-text
                  class="pt-0 pb-4 white--text"
                >
                  <v-col>
                    <v-row class="headline">
                      <span>{{ formatNumber(metric.metricType.value, metric[metric.metricType.value]) }}</span>
                    </v-row>

                    <v-row>
                      <v-col class="pa-0">
                        <span>{{ metric.metricType.text }}</span>
                        <span v-if="metric.metricGroupBy">
                          across
                          <span class="font-weight-medium">
                            {{ formatNumber(metric.metricGroupBy.value, metric[metric.metricGroupBy.value]) }}
                          </span>
                          {{ metric.metricGroupBy.text }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-col>
          </v-slide-item>
        </v-slide-group>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import format from 'src/utils/format'

const { mapState: mapDashboardState } = createNamespacedHelpers('dashboard')
const { mapState: mapLayoutState } = createNamespacedHelpers('layout')
const { mapGetters: mapToolsGetters } = createNamespacedHelpers('tools')

export default {
  name: 'MetricBar',
  props: {
    metrics: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      slideMetrics: [],
    }
  },
  computed: {
    ...mapDashboardState({
      metricGroupByMap: (state) => state.metricGroupByMap,
      metricTypeMap: (state) => state.metricTypeMap,
    }),
    ...mapLayoutState({
      $isLayoutFullScreen: (state) => state.isLayoutFullScreen,
    }),
    ...mapToolsGetters([
      'currentMetric',
      'currentSelectedReport',
    ]),
    query() {
      return this.$route.query
    },
    showMetricBar() {
      return !this.$isLayoutFullScreen
    },
  },
  methods: {
    formatNumber(metricType, value) {
      const formatMap = {
        totalHours: format.hhmm,
      }
      return typeof formatMap[metricType] === 'function' ? formatMap[metricType](value) : format.number(value)
    },
    isCurrentlyActiveStandalone(report) {
      const { currentSelectedReport } = this
      const { docId, reportPath } = currentSelectedReport || {}
      return currentSelectedReport && (reportPath === report.reportPath || docId === report.docId)
    },
    isCurrentlyActiveMetric(report) {
      const { currentMetric } = this
      const { docId, reportPath } = currentMetric || {}
      return currentMetric && (reportPath === report.reportPath || docId === report.docId)
    },
    toggleMetric(metricReport) {
      const { currentMetric } = this
      if (currentMetric && currentMetric.docId === metricReport.docId) {
        this.$router.replace({
          params: this.$route.params,
          query: {
            ...this.query,
            metricPath: null,
          },
        })
      } else {
        this.$router.replace({
          params: this.$route.params,
          query: {
            ...this.query,
            metricPath: metricReport.reportPath,
          },
        })
      }
    },
  },
}
</script>
